import { PHONE_DISPLAY, PHONE_E164 } from '@/lib/contact';
import { cn } from '@/lib/utils';

interface PhoneCallLinkProps {
  children: React.ReactNode;
  className?: string;
  /**
   * Accessible name for the link. Keep the visible label inside it
   * (WCAG 2.5.3 Label in Name) and append the number for screen readers.
   */
  ariaLabel?: string;
}

/**
 * Direct-call link (`tel:`) to the public business number.
 *
 * Clicking opens the device dialer with the number prefilled — the number
 * itself is the single source of truth in `@/lib/contact`.
 */
export function PhoneCallLink({ children, className, ariaLabel }: PhoneCallLinkProps) {
  return (
    <a
      href={`tel:${PHONE_E164}`}
      className={cn(className)}
      aria-label={ariaLabel}
      title={PHONE_DISPLAY}
    >
      {children}
    </a>
  );
}
